const CellTags = ({ tags }: { tags?: Array<string> | null }) => {
    return (
        <>
            <div className="thematic-react-tag-wrapper gap-1 mt-1 mb-1">
                {tags?.map((tag: string, index: number) => (
                    <div key={index} className="thematic-react-tag">
                        {tag}
                    </div>
                ))}
            </div>
        </>
    );
};

export default CellTags;
